import React from "react";
import { otpRegister, changePassword } from "../../services/rest";
import Validator from "../../utils/Validator";
import PasswordCheckBox from "../Password/PasswordCheckBox";
import ErrorHandler from "../../utils/error-handler";
import TaggingHelper from "../../tagging/tagging-helper";

class CreatePassword extends React.Component {
  defaultState = {
    hidden: true,
    password: "",
    passwordActive: false,
    isInValidPassword: true,
    rules: {
      isValidLength: false,
      isLowerCase: false,
      isUpperCase: false,
      hasNumber: false
    },
    previousPropData: null
  };
  constructor(props) {
    super(props);
    if (props.data && props.data.previousState) {
      this.state = {
        ...props.data.previousState
      };
    } else {
      this.state = {
        ...this.defaultState,
        previousPropData: props.data.currentState
      };
    }
  }
  componentDidMount() {
    if (this.props.changeFlag) {
      TaggingHelper.changePasswordLandingEvent();
    } else {
      TaggingHelper.createPasswordLandingEvent();
    }
  }
  activateField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: true
    });
  };

  disableField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: false
    });
  };

  _onInputChange = (e) => {
    this.setState({
      password: e.target.value,
      isInValidPassword: this.inValidPassword(e.target.value),
      rules: {
        isLowerCase: !!e.target.value.match(/(?=.*[a-z])/),
        isUpperCase: !!e.target.value.match(/(?=.*[A-Z])/),
        isValidLength: !!e.target.value.match(/.{8,}/),
        hasNumber: !!e.target.value.match(/(?=.*\d)/)
      }
    });
  };

  toggleShow = () => {
    this.setState((pstate) => ({
      hidden: !pstate.hidden
    }));
  };

  inValidPassword = (password) => {
    return !Validator.isValidPassword(password);
  };

  handleChangePassword = () => {
    this.props.showUILoader(true);
    changePassword(
      this.state.previousPropData.previousPropData.username,
      this.state.password
    )
      .then((response) => {
        if (response.data && response.data.result) {
          const message = response.data.result.message || "";
          this.props.goto("LOGIN", { toastMessage: message });
          TaggingHelper.changePasswordSuccessEvent();
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        ErrorHandler.handleApiError(
          error,
          this.props.goto,
          this.state,
          "CHANGE_PASSWORD"
        );
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.forgotPasswordErrorEvent(errorMessage);
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };
  _onPasswordValid = (e) => {
    e.preventDefault();
    if (this.props.changeFlag) {
      this.handleChangePassword();
      TaggingHelper.changePasswordValidationEvent();
    } else {
      this.handleCreatePassword();
    }
  };
  handleCreatePassword = () => {
    const { password } = this.state;
    const { name, cellnum, token, username } = this.state.previousPropData;
    this.props.showUILoader(true);
    otpRegister(username, name, cellnum, password, token)
      .then((response) => {
        if (response.data && response.status === 200 && response.data.result) {
          const message = response.data.result.message || "";
          this.props.goto("REGISTRATION_OTP", {
            currentState: this.state,
            message
          });
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        ErrorHandler.handleApiError(
          error,
          this.props.goto,
          this.state.previousPropData,
          "CREATE_PROFILE"
        );
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.registrationErrorEvent(errorMessage);
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };
  onGoBack = () => {
    if (this.props.changeFlag) {
      this.props.goto("FORGOT_PASSWORD", {
        previousState: this.state.previousPropData.previousPropData
      });
    } else {
      this.props.goto("CREATE_PROFILE", {
        previousState: this.state.previousPropData
      });
    }
  };
  render() {
    const { goto, changeFlag } = this.props;
    const { passwordActive, password, hidden, isInValidPassword } = this.state;
    const cardTitle = changeFlag ? "Change Password" : "Create Password";
    return (
      <React.Fragment>
        <div className="card-header">
          <h2>{cardTitle}</h2>
          <p>
            Already have an account ?{" "}
            <button
              type="button"
              className="button-link"
              onClick={() => {
                goto("LOGIN");
              }}
              automationid="REGISTRATION_FORM_CREATEPASSWORD_1"
            >
              Log in
            </button>
          </p>
        </div>
        <div className="field-group">
          <label className={passwordActive || password ? "active" : ""}>
            {"Password"}
          </label>
          <div className="loginDetailsFormInputContainer">
            <input
              onChange={this._onInputChange}
              value={password}
              type={hidden ? "password" : "text"}
              name="password"
              automationid="REGISTRATION_FORM_CREATEPASSWORD_2"
              className={
                !passwordActive && password && isInValidPassword ? "error" : ""
              }
              onFocus={this.activateField}
              onBlur={this.disableField}
            />
            <span
              className={`loginDetailsFormInputHelper ${
                password ? " " : "invisible-element"
              }`}
              onClick={this.toggleShow}
            >
              {hidden ? "SHOW" : "HIDE"}
            </span>
          </div>
        </div>
        <PasswordCheckBox
          isValidLength={this.state.rules.isValidLength}
          isLowerCase={this.state.rules.isLowerCase}
          isUpperCase={this.state.rules.isUpperCase}
          hasNumber={this.state.rules.hasNumber}
        />
        <div className="action-button-wrapper">
          <button
            type="submit"
            className="btn btnRed"
            disabled={this.state.isInValidPassword}
            onClick={(e) => this._onPasswordValid(e)}
            automationid="REGISTRATION_FORM_CREATEPASSWORD_3"
          >
            Next
          </button>
        </div>
        <div className="action-button-wrapper">
          <button
            type="button"
            className="btn btnWhite"
            onClick={this.onGoBack}
            automationid="REGISTRATION_FORM_CREATEPASSWORD_4"
          >
            Back
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default CreatePassword;
